export var ModalKeys;
(function (ModalKeys) {
    ModalKeys["SHARE_TRIP"] = "share-trip";
    ModalKeys["INVITE_USERS"] = "invite-users";
    ModalKeys["DRAFTS"] = "drafts";
    // Add more modal keys here
})(ModalKeys || (ModalKeys = {}));
